// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","copy":"Footer_copy__V37yO","links":"Footer_links__wMgLO","link":"Footer_link__3Ie8d"};